// import React from 'react';
// import './SalesDashboard.css';

// const SalesDashboard = () => {
//   // Top Stats Data
//   const statsData = [
//     { id: 'stat-sourcing', label: 'SOURCING', value: '4', sub: '₹11,95,000' },
//     { id: 'stat-enquiry', label: 'ENQUIRY', value: '2', sub: '₹2,75,000' },
//     { id: 'stat-quote', label: 'QUOTE', value: '1', sub: '₹9,20,000' },
//     { id: 'stat-approval', label: 'APPROVAL', value: '1', sub: '₹9,20,000' },
//     { id: 'stat-po', label: 'PO', value: '1', sub: '₹9,20,000' },
//     { id: 'stat-execution', label: 'EXECUTION', value: '1', sub: '₹9,20,000' },
//     { id: 'stat-payment', label: 'PAYMENT', value: '2', sub: '₹9,20,000' },
//     { id: 'stat-pending', label: 'PENDING', value: '3', sub: '₹5,35,000 pending' },
//   ];

//   // Pipeline Stages Data
//   const pipelineStages = ['Sourcing', 'Enquiry', 'Quote', 'Approval', 'PO', 'Execution', 'Payment'];
//   const pipelineCounts = [4, 2, 1, 1, 1, 1, 2];
//   const pipelineValues = ['₹11,95,000', '₹2,75,000', '₹9,20,000', '₹9,20,000', '₹9,20,000', '₹9,20,000', '₹9,20,000'];

//   // Enquiry Status Cards
//   const enquiryStatusCards = [
//     { name: 'Pending Quote', count: 1, value: '₹0', color: 'pending' },
//     { name: 'Quote Submitted', count: 1, value: '₹2,75,000', color: 'submitted' },
//     { name: 'Approved', count: 1, value: '₹9,20,000', color: 'approved' },
//     { name: 'Rejected', count: 0, value: '₹0', color: 'rejected' },
//     { name: 'Revision', count: 0, value: '₹0', color: 'revision' },
//   ];

//   // Project Status Cards
//   const projectStatusCards = [
//     { name: 'Initiated', count: 0, value: '₹0', color: 'initiated' },
//     { name: 'In Progress', count: 1, value: '₹9,20,000', color: 'progress' },
//     { name: 'Completed', count: 0, value: '₹0', color: 'completed' },
//   ];

//   // Recent Enquiries Data
//   const recentEnquiriesData = [
//     { id: 'ENQ-X1Y2Z', client: 'Acme Industries', quote: '₹9,20,000', status: 'Approved', clientStatus: 'Accepted', owner: 'Priya (Exec)' },
//     { id: 'ENQ-M3N4O', client: 'Acme Industries', quote: '₹2,75,000', status: 'Quote Submitted', clientStatus: 'Negotiation', owner: 'Karan (Exec)' },
//     { id: 'ENQ-59AHL', client: 'Orbit Logistics', quote: '—', status: 'Pending Quote', clientStatus: '—', owner: 'Priya (Exec)' },
//   ];

//   return (
//     <div className="sd-dashboard-container">
//       <div className="sd-dashboard-wrapper">
//         {/* Top Stats Grid */}
//         <div className="sd-top-stats-grid">
//           {statsData.map((stat) => (
//             <div key={stat.id} className="sd-top-stat-card">
//               <div className="sd-top-stat-label">{stat.label}</div>
//               <div className="sd-top-stat-value">{stat.value}</div>
//               {stat.sub && <div className="sd-top-stat-sub">{stat.sub}</div>}
//             </div>
//           ))}
//         </div>

//         {/* Pipeline Flow Section */}
//         <div className="sd-pipeline-area">
//           <h2 className="sd-section-heading">Pipeline Flow</h2>
//           <div className="sd-pipeline-track">
//             {pipelineStages.map((stage, idx) => (
//               <React.Fragment key={idx}>
//                 <div className="sd-pipeline-node">
//                   <div className="sd-pipeline-name">{stage}</div>
//                   <div className="sd-pipeline-counter">{pipelineCounts[idx]}</div>
//                   <div className="sd-pipeline-amount">{pipelineValues[idx]}</div>
//                 </div>
//                 {idx < pipelineStages.length - 1 && (
//                   <div className="sd-pipeline-connector">→</div>
//                 )}
//               </React.Fragment>
//             ))}
//           </div>
//         </div>

//         {/* Two Column Layout: Enquiry Status + Project Status */}
//         <div className="sd-two-column-layout">
//           {/* Enquiry Status Cards Section */}
//           <div className="sd-enquiry-status-area">
//             <h2 className="sd-section-heading">Enquiry status</h2>
//             <div className="sd-status-cards-grid">
//               {enquiryStatusCards.map((card, idx) => (
//                 <div key={idx} className={`sd-status-card sd-status-card-${card.color}`}>
//                   <div className="sd-status-card-name">{card.name}</div>
//                   <div className="sd-status-card-count">{card.count}</div>
//                   <div className="sd-status-card-value">{card.value}</div>
//                 </div>
//               ))}
//             </div>
//           </div>

//           {/* Project Status Cards Section */}
//           <div className="sd-project-status-area">
//             <h2 className="sd-section-heading">Project status</h2>
//             <div className="sd-status-cards-grid">
//               {projectStatusCards.map((card, idx) => (
//                 <div key={idx} className={`sd-status-card sd-status-card-${card.color}`}>
//                   <div className="sd-status-card-name">{card.name}</div>
//                   <div className="sd-status-card-count">{card.count}</div>
//                   <div className="sd-status-card-value">{card.value}</div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>

//         {/* Recent Enquiries Section */}
//         <div className="sd-recent-area">
//           <div className="sd-recent-header">
//             <h2 className="sd-section-heading">Recent enquiries</h2>
//             <a href="#" className="sd-view-all-link">View all →</a>
//           </div>

//           <div className="sd-table-wrapper">
//             <table className="sd-data-table">
//               <thead>
//                 <tr className="sd-table-header-row">
//                   <th className="sd-table-header">ID</th>
//                   <th className="sd-table-header">CLIENT</th>
//                   <th className="sd-table-header">QUOTE</th>
//                   <th className="sd-table-header">STATUS</th>
//                   <th className="sd-table-header">CLIENT STATUS</th>
//                   <th className="sd-table-header">OWNER</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {recentEnquiriesData.map((row, idx) => (
//                   <tr key={idx} className="sd-table-row">
//                     <td className="sd-table-cell">{row.id}</td>
//                     <td className="sd-table-cell">{row.client}</td>
//                     <td className="sd-table-cell">{row.quote}</td>
//                     <td className="sd-table-cell">
//                       <span className={`sd-status-badge sd-badge-${row.status.toLowerCase().replace(/\s+/g, '-')}`}>
//                         {row.status}
//                       </span>
//                     </td>
//                     <td className="sd-table-cell">
//                       {row.clientStatus !== '—' ? (
//                         <span className={`sd-client-badge sd-client-${row.clientStatus.toLowerCase()}`}>
//                           {row.clientStatus}
//                         </span>
//                       ) : (
//                         <span className="sd-client-badge sd-client-empty">—</span>
//                       )}
//                     </td>
//                     <td className="sd-table-cell">{row.owner}</td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SalesDashboard;







import React, { useState, useEffect } from 'react';
import './SalesDashboard.css';
import { getAllEnquiries } from '../../../Servicefile/salesService';

const SalesDashboard = () => {
  // ============================================
  // STATE
  // ============================================
  const [enquiries, setEnquiries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState({
    totalEnquiries: 0,
    totalBudget: 0,
    enquiry: { count: 0, budget: 0 },        // PENDING
    approval: { count: 0, budget: 0 },        // APPROVED
    quote: { count: 0, budget: 0 },           // PAYMENT_RECEIVED
    assigned: { count: 0, budget: 0 },        // ASSIGNED
    completed: { count: 0, budget: 0 },       // CLOSED
    rejected: { count: 0, budget: 0 },        // REJECTED
  });

  // Pipeline Stages Data
  const [pipelineData, setPipelineData] = useState({
    stages: ['Enquiry', 'Approval', 'Quote', 'Assigned', 'Completed', 'Rejected'],
    counts: [0, 0, 0, 0, 0, 0],
    values: ['₹0', '₹0', '₹0', '₹0', '₹0', '₹0']
  });

  // Enquiry Status Cards
  const [enquiryStatusCards, setEnquiryStatusCards] = useState([
    { name: 'Pending', count: 0, value: '₹0', color: 'pending' },
    { name: 'Approved', count: 0, value: '₹0', color: 'approved' },
    { name: 'Quoted', count: 0, value: '₹0', color: 'submitted' },
    { name: 'Assigned', count: 0, value: '₹0', color: 'assigned' },
    { name: 'Completed', count: 0, value: '₹0', color: 'completed' },
    { name: 'Rejected', count: 0, value: '₹0', color: 'rejected' },
  ]);

  // Project Status Cards
  const [projectStatusCards, setProjectStatusCards] = useState([
    { name: 'Initiated', count: 0, value: '₹0', color: 'initiated' },
    { name: 'In Progress', count: 0, value: '₹0', color: 'progress' },
    { name: 'Completed', count: 0, value: '₹0', color: 'completed' },
  ]);

  // Recent Enquiries
  const [recentEnquiries, setRecentEnquiries] = useState([]);

  // ============================================
  // FETCH DATA
  // ============================================
  const fetchDashboardData = async () => {
    setLoading(true);
    try {
      const data = await getAllEnquiries();
      setEnquiries(data || []);
      calculateStats(data || []);
      updateRecentEnquiries(data || []);
    } catch (error) {
      console.error('Error fetching dashboard data:', error);
    } finally {
      setLoading(false);
    }
  };

  // ============================================
  // CALCULATE STATS
  // ============================================
  const calculateStats = (data) => {
    // Helper: Count and sum budget for a specific status
    const getStatusStats = (status) => {
      const items = data.filter(e => e.leadStatus === status);
      const count = items.length;
      const budget = items.reduce((sum, e) => sum + (e.budget || 0), 0);
      return { count, budget };
    };

    // Calculate each status
    const enquiry = getStatusStats('PENDING');
    const approval = getStatusStats('APPROVED');
    const quote = getStatusStats('PAYMENT_RECEIVED');
    const assigned = getStatusStats('ASSIGNED');
    const completed = getStatusStats('CLOSED');
    const rejected = getStatusStats('REJECTED');

    // Total enquiries and budget
    const totalEnquiries = data.length;
    const totalBudget = data.reduce((sum, e) => sum + (e.budget || 0), 0);

    setStats({
      totalEnquiries,
      totalBudget,
      enquiry,
      approval,
      quote,
      assigned,
      completed,
      rejected,
    });

    // Update Pipeline Data
    setPipelineData({
      stages: ['Enquiry', 'Approval', 'Quote', 'Assigned', 'Completed', 'Rejected'],
      counts: [
        enquiry.count,
        approval.count,
        quote.count,
        assigned.count,
        completed.count,
        rejected.count
      ],
      values: [
        formatCurrency(enquiry.budget),
        formatCurrency(approval.budget),
        formatCurrency(quote.budget),
        formatCurrency(assigned.budget),
        formatCurrency(completed.budget),
        formatCurrency(rejected.budget)
      ]
    });

    // Update Enquiry Status Cards
    setEnquiryStatusCards([
      { name: 'enquiry', count: enquiry.count, value: formatCurrency(enquiry.budget), color: 'pending' },
      { name: 'Approved', count: approval.count, value: formatCurrency(approval.budget), color: 'approved' },
      { name: 'Quoted', count: quote.count, value: formatCurrency(quote.budget), color: 'submitted' },
      { name: 'Assigned', count: assigned.count, value: formatCurrency(assigned.budget), color: 'assigned' },
      { name: 'Completed', count: completed.count, value: formatCurrency(completed.budget), color: 'completed' },
      { name: 'Rejected', count: rejected.count, value: formatCurrency(rejected.budget), color: 'rejected' },
    ]);

    // Update Project Status Cards
    const initiated = data.filter(e => e.leadStatus === 'ASSIGNED' || e.leadStatus === 'ACCEPT');
    const inProgress = data.filter(e => e.leadStatus === 'APPROVED' || e.leadStatus === 'PAYMENT_RECEIVED');
    const completedProjects = data.filter(e => e.leadStatus === 'CLOSED');

    setProjectStatusCards([
      {
        name: 'Initiated',
        count: inProgress.length,
        value: formatCurrency(inProgress.reduce((sum, e) => sum + (e.budget || 0), 0)),
        color: 'initiated'
      },
      {
        name: 'In Progress',
        count: initiated.length,
        value: formatCurrency(initiated.reduce((sum, e) => sum + (e.budget || 0), 0)),
        color: 'progress'
      },
      {
        name: 'Completed',
        count: completedProjects.length,
        value: formatCurrency(completedProjects.reduce((sum, e) => sum + (e.budget || 0), 0)),
        color: 'completed'
      },
    ]);
  };

  // ============================================
  // UPDATE RECENT ENQUIRIES
  // ============================================
  const updateRecentEnquiries = (data) => {
    // Get only PENDING leads, sorted by newest first, take top 3
    const pendingLeads = data
      .filter(e => e.leadStatus === 'PENDING')
      .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
      .slice(0, 3)
      .map(e => ({
        id: e.enquiryId || e.id || 'N/A',
        client: e.companyName || e.fullName || 'Unknown',
        quote: formatCurrency(e.budget || 0),
        status: 'Pending',
        clientStatus: '—',
        owner: e.sourceBy || 'N/A'
      }));

    setRecentEnquiries(pendingLeads);
  };

  // ============================================
  // FORMAT HELPERS
  // ============================================
  const formatCurrency = (amount) => {
    if (!amount) return '₹0';
    return `₹${Number(amount).toLocaleString('en-IN')}`;
  };

  // ============================================
  // HANDLE VIEW ALL
  // ============================================
  const handleViewAll = () => {
    // Dispatch event to switch to Enquiries tab
    const event = new CustomEvent('changeTab', { detail: { tabId: 'enquiries' } });
    window.dispatchEvent(event);
  };

  // ============================================
  // EFFECTS
  // ============================================
  useEffect(() => {
    fetchDashboardData();
  }, []);

  // ============================================
  // RENDER
  // ============================================
  return (
    <div className="sd-dashboard-container">
      <div className="sd-dashboard-wrapper">
        {loading ? (
          <div style={loadingStyle}>
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p>Loading dashboard data...</p>
          </div>
        ) : (
          <>
            {/* Top Stats Grid - 8 Cards */}
            <div className="sd-top-stats-grid">
              {/* Total Enquiries */}
              <div className="sd-top-stat-card sd-stat-total">
                <div className="sd-top-stat-label">TOTAL LEADS</div>
                <div className="sd-top-stat-value">{stats.totalEnquiries}</div>
                <div className="sd-top-stat-sub">Total count</div>
              </div>

              {/* Enquiry (PENDING) */}
              <div className="sd-top-stat-card">
                <div className="sd-top-stat-label">ENQUIRY</div>
                <div className="sd-top-stat-value">{stats.enquiry.count}</div>
                <div className="sd-top-stat-sub">{formatCurrency(stats.enquiry.budget)}</div>
              </div>

              {/* Approval (APPROVED) */}
              <div className="sd-top-stat-card">
                <div className="sd-top-stat-label">APPROVAL</div>
                <div className="sd-top-stat-value">{stats.approval.count}</div>
                <div className="sd-top-stat-sub">{formatCurrency(stats.approval.budget)}</div>
              </div>

              {/* Quote (PAYMENT_RECEIVED) */}
              <div className="sd-top-stat-card">
                <div className="sd-top-stat-label">QUOTE</div>
                <div className="sd-top-stat-value">{stats.quote.count}</div>
                <div className="sd-top-stat-sub">{formatCurrency(stats.quote.budget)}</div>
              </div>

              {/* Assigned (ASSIGNED) */}
              <div className="sd-top-stat-card">
                <div className="sd-top-stat-label">ASSIGNED</div>
                <div className="sd-top-stat-value">{stats.assigned.count}</div>
                <div className="sd-top-stat-sub">{formatCurrency(stats.assigned.budget)}</div>
              </div>

              {/* Completed (CLOSED) */}
              <div className="sd-top-stat-card">
                <div className="sd-top-stat-label">COMPLETED</div>
                <div className="sd-top-stat-value">{stats.completed.count}</div>
                <div className="sd-top-stat-sub">{formatCurrency(stats.completed.budget)}</div>
              </div>

              {/* Rejected (REJECTED) */}
              <div className="sd-top-stat-card">
                <div className="sd-top-stat-label">REJECTED</div>
                <div className="sd-top-stat-value">{stats.rejected.count}</div>
                <div className="sd-top-stat-sub">{formatCurrency(stats.rejected.budget)}</div>
              </div>
              {/* Total Budget */}
              <div className="sd-top-stat-card sd-stat-total">
                <div className="sd-top-stat-label">TOTAL BUDGET</div>
                <div className="sd-top-stat-value">{formatCurrency(stats.totalBudget)}</div>
                <div className="sd-top-stat-sub">All enquiries</div>
              </div>
            </div>

            {/* Pipeline Flow Section */}
            <div className="sd-pipeline-area">
              <h2 className="sd-section-heading">Pipeline Flow</h2>
              <div className="sd-pipeline-track">
                {pipelineData.stages.map((stage, idx) => (
                  <React.Fragment key={idx}>
                    <div className="sd-pipeline-node">
                      <div className="sd-pipeline-name">{stage}</div>
                      <div className="sd-pipeline-counter">{pipelineData.counts[idx]}</div>
                      <div className="sd-pipeline-amount">{pipelineData.values[idx]}</div>
                    </div>
                    {idx < pipelineData.stages.length - 1 && (
                      <div className="sd-pipeline-connector">→</div>
                    )}
                  </React.Fragment>
                ))}
              </div>
            </div>

            {/* Two Column Layout: Enquiry Status + Project Status */}
            {/* <div className="sd-two-column-layout">
              <div className="sd-enquiry-status-area">
                <h2 className="sd-section-heading">Enquiry status</h2>
                <div className="sd-status-cards-grid">
                  {enquiryStatusCards.map((card, idx) => (
                    <div key={idx} className={`sd-status-card sd-status-card-${card.color}`}>
                      <div className="sd-status-card-name">{card.name}</div>
                      <div className="sd-status-card-count">{card.count}</div>
                      <div className="sd-status-card-value">{card.value}</div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="sd-project-status-area">
                <h2 className="sd-section-heading">Project status</h2>
                <div className="sd-status-cards-grid">
                  {projectStatusCards.map((card, idx) => (
                    <div key={idx} className={`sd-status-card sd-status-card-${card.color}`}>
                      <div className="sd-status-card-name">{card.name}</div>
                      <div className="sd-status-card-count">{card.count}</div>
                      <div className="sd-status-card-value">{card.value}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div> */}

            {/* Recent Enquiries Section */}
            <div className="sd-recent-area">
              <div className="sd-recent-header">
                <h2 className="sd-section-heading">Recent enquiries</h2>
                <a
                  href="#"
                  className="sd-view-all-link"
                  onClick={(e) => {
                    e.preventDefault();
                    handleViewAll();
                  }}
                >
                  View all →
                </a>
              </div>

              <div className="sd-table-wrapper">
                <table className="sd-data-table">
                  <thead>
                    <tr className="sd-table-header-row">
                      <th className="sd-table-header">ID</th>
                      <th className="sd-table-header">CLIENT</th>
                      <th className="sd-table-header">QUOTE</th>
                      <th className="sd-table-header">STATUS</th>
                      <th className="sd-table-header">CLIENT STATUS</th>
                      <th className="sd-table-header">OWNER</th>
                    </tr>
                  </thead>
                  <tbody>
                    {recentEnquiries.length > 0 ? (
                      recentEnquiries.map((row, idx) => (
                        <tr key={idx} className="sd-table-row">
                          <td className="sd-table-cell">{row.id}</td>
                          <td className="sd-table-cell">{row.client}</td>
                          <td className="sd-table-cell">{row.quote}</td>
                          <td className="sd-table-cell">
                            <span className="sd-status-badge sd-badge-pending-quote">
                              {row.status}
                            </span>
                          </td>
                          <td className="sd-table-cell">
                            <span className="sd-client-badge sd-client-empty">—</span>
                          </td>
                          <td className="sd-table-cell">{row.owner}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="6" style={{ textAlign: 'center', padding: '30px', color: '#9CA3AF' }}>
                          No recent enquiries
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        )}
      </div>

      <style>{`
                .spinner-border {
                    display: inline-block;
                    width: 2rem;
                    height: 2rem;
                    border: 0.25em solid currentColor;
                    border-right-color: transparent;
                    border-radius: 50%;
                    animation: spinner-border 0.75s linear infinite;
                }
                @keyframes spinner-border {
                    to { transform: rotate(360deg); }
                }
                .visually-hidden {
                    position: absolute;
                    width: 1px;
                    height: 1px;
                    padding: 0;
                    margin: -1px;
                    overflow: hidden;
                    clip: rect(0, 0, 0, 0);
                    border: 0;
                }
            `}</style>
    </div>
  );
};

// ─── Styles ──────────────────────────────────────────────────────
const loadingStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '60px 20px',
  gap: '16px',
  color: '#6B7280',
  fontSize: '14px',
};

export default SalesDashboard;